module.exports = __webpack_public_path__ + "static/media/  (71).f7c90a9e.jpg";